module.exports = __webpack_public_path__ + "images/5671d4b77831fe5e2bb2bc8eecfdb846-profile_overlay.jpg";